/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import moment from 'moment';
import * as toast from '../../_store/slice/toast';
import server from '../../_api/backend';

type oneBookParams = {
  oneBookCode: string;
  oneBookImage: string;
  oneBookName: string;
  oneBookPrice: string;
  oneBookQty: string;
};

export function Order(props: RouteComponentProps) {
  const { location } = props;
  const {
    oneBookCode,
    oneBookImage,
    oneBookName,
    oneBookPrice,
    oneBookQty,
  } = location.state as oneBookParams;
  const [searchVisable, setSearchVisable] = useState(false);
  const [addrKeyword, setAddrKeyword] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [addressItem, setAddressItem] = useState<any[]>([]);
  const [shippingPrice, setShippingPrice] = useState<number>(0);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [isSameBuyerInfo, setIsSameBuyerInfo] = useState<boolean>(false);
  const dispatch = useDispatch();

  // 구매자 & 주문자 정보
  const [orderUserName, setOrderUserName] = useState<string>('');
  const [bookCode, setBookCode] = useState<string>('');
  const [bookName, setBookName] = useState<string>('');
  const [bookPrice, setBookPrice] = useState<number>(0);
  const [purchaserName, setPurchaserName] = useState<string>('');
  const [purchaserEmail, setPurchaserEmail] = useState<string>('');
  const [purchaserAddr, setPurchaserAddr] = useState<string>('');
  const [orderQty, setOrderQty] = useState<number>(0);
  const [purTel1, setPurTel1] = useState<string>('');
  const [purTel2, setPurTel2] = useState<string>('');
  const [purTel3, setPurTel3] = useState<string>('');
  const [purPhone1, setPurPhone1] = useState<string>('');
  const [purPhone2, setPurPhone2] = useState<string>('');
  const [purPhone3, setPurPhone3] = useState<string>('');
  const [post, setPost] = useState<string>('');
  const [addr, setAddr] = useState<string>('');
  const [receiverName, setReceiverName] = useState<string>('');
  const [receiverEmail, setReceiverEmail] = useState<string>('');
  const [reTel1, setReTel1] = useState<string>('');
  const [reTel2, setReTel2] = useState<string>('');
  const [reTel3, setReTel3] = useState<string>('');
  const [rePhone1, setRePhone1] = useState<string>('');
  const [rePhone2, setRePhone2] = useState<string>('');
  const [rePhone3, setRePhone3] = useState<string>('');
  const [receiverPost, setReceiverPost] = useState<string>('');
  const [receiverAddr, setReceiverAddr] = useState<string>('');
  const [receiverDetailAddr, setReceiverDetailAddr] = useState<string>('');
  const [payer, setPayer] = useState<string>('');
  const [salesPrice, setSalesPrice] = useState<number>(0);
  const [paymentAmount, setPaymentAmount] = useState<number>(0);
  const [etc, setEtc] = useState<string>('');

  const [internetExplorer, setInternetExplorer] = useState<boolean>(false);
  const [bankhost] = useState<string>('조규백');
  const [payState] = useState<string>('입금대기');
  const [jumunSun] = useState<string>('000');
  const [memGbn] = useState<string>('도서출판 구민사');
  const [bank] = useState<string>('국민은행 054901-04-133407');
  const [paymentOption] = useState<string>('무통장입금');
  const [point] = useState<number>(0);
  const [usepoint] = useState<number>(0);
  const [yearOption, setYearOption] = useState<any>(new Date().getFullYear());
  const [monthOption, setMonthOption] = useState<any>((new Date().getMonth() + 1).toString());
  const [dateOption, setDateOption] = useState<any>(new Date().getDate());

  const phoneRule = /^\d{3}-\d{3,4}-\d{4}$/;
  const history = useHistory();

  const param = [
    {
      orderUserName,
      bookCode,
      bookName,
      bookPrice,
      purchaserName,
      purchaserEmail,
      orderQty,
      purchaserTel: `${purTel1}-${purTel2}-${purTel3}`,
      purchaserPhone: `${purPhone1}-${purPhone2}-${purPhone3}`,
      post,
      addr,
      receiverName,
      receiverEmail,
      receiverTel: `${reTel1}-${reTel2}-${reTel3}`,
      receiverPhone: `${rePhone1}-${rePhone2}-${rePhone3}`,
      receiverPost,
      receiverAddr: `${receiverAddr} ${receiverDetailAddr}`,
      paymentOption,
      paymentAmount,
      payer,
      yeyakDate: convertDate(`${yearOption}-${monthOption}-${dateOption}`),
      etc,
      bank,
      bankhost,
      point,
      usepoint,
      paymentDate: convertDate(`${yearOption}-${monthOption}-${dateOption}`),
      payState,
      sDate: new Date(),
      salesPrice,
      jumunSun,
      memGbn,
    },
  ];

  function convertDate(dateString: string): string {
    const parsedDate = moment(dateString, ['YYYY-M-D', 'YYYY-MM-DD'], true);
    if (parsedDate.isValid()) {
      return parsedDate.format('YYYY-MM-DD');
    }
    return dateString;
  }

  useEffect(() => {
    checkAccount();
    getPurchaser();
    setBookCode(oneBookCode);
    setBookName(oneBookName);
    setBookPrice(Number(oneBookPrice));
    setOrderQty(Number(oneBookQty));
  }, []);

  useEffect(() => {
    getShippingPrice();
    const agent = navigator.userAgent.toLowerCase();
    if (
      (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) ||
      agent.indexOf('msie') !== -1
    ) {
      setInternetExplorer(true);
    }
  }, []);

  // 회원인지 ,비회원인지 확인 후 비회원일 시 로그인 창으로 이동
  const checkAccount = async () => {
    await server
      .getUserOwn()
      .then((payload) => {
        if (payload && !payload.name) {
          dispatch(toast.error({ message: '주문하기는 로그인이 필요합니다.' }));
          history.push('/login');
        }
      })
      .catch((e: Error) => console.log(e));
  };

  useEffect(() => {
    searchPostcode().then(() => {});
  }, [currentPage]);

  // 주문하는분 정보 기본값
  const [
    purchaserInfo = {
      name: purchaserName,
      address: addr,
      tel: `${reTel1}-${reTel2}-${reTel3}`,
      phone: `${rePhone1}-${rePhone2}-${rePhone3}`,
      email: purchaserEmail,
    },
    setPurchaserInfo,
  ] = useState<any>();

  // 주문자 정보 조회 API  호출
  const getPurchaser = async () => {
    await server
      .getUserOwn()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          if (payload.data !== '') {
            setOrderUserName(payload.username);
            setPurchaserInfo(payload);
            setPurchaserName(payload.name);
            setPayer(payload.name);
            setPurchaserEmail(payload.email);
            setPurchaserAddr(payload.address);
            setPost(payload.post);
            setAddr(payload.address);
          }
          if (payload.tel !== undefined) {
            setPurTel1(payload.tel.split('-')[0]);
            setPurTel2(payload.tel.split('-')[1]);
            setPurTel3(payload.tel.split('-')[2]);
          }
          if (payload.phone !== undefined) {
            setPurPhone1(payload.phone.split('-')[0]);
            setPurPhone2(payload.phone.split('-')[1]);
            setPurPhone3(payload.phone.split('-')[2]);
          }
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 주문자 <-> 받는분 일치 여부 확인
  const onCheckReceiverInfo = (data: any) => {
    setIsSameBuyerInfo(data);
    if (data) {
      setReceiverAddr(purchaserAddr);
      setReceiverName(purchaserName);
      setReceiverEmail(purchaserEmail);
      setReTel1(purTel1);
      setReTel2(purTel2);
      setReTel3(purTel3);
      setRePhone1(purPhone1);
      setRePhone2(purPhone2);
      setRePhone3(purPhone3);
    } else {
      setReceiverAddr('');
      setReTel1('');
      setReTel2('');
      setReTel3('');
      setRePhone1('');
      setRePhone2('');
      setRePhone3('');
    }
  };

  // 장바구니 테이블 생성
  function createCartList() {
    return <div className="table">{oneBookRow}</div>;
  }

  // 바로구매값 불러오기
  const oneBookRow = (
    <ul className="row" key={oneBookCode}>
      <li className="thumbnail">
        <img src={oneBookImage} alt="" />
      </li>
      <li className="book-title">{oneBookName}</li>
      <li className="price">{Number(oneBookPrice).toLocaleString()}</li>
      <li className="quantity">{Number(oneBookQty).toLocaleString()}</li>
      <li className="price">{(Number(oneBookPrice) * Number(oneBookQty)).toLocaleString()}</li>
    </ul>
  );

  // 배송관리(배송비) 조회 API 호출
  const getShippingPrice = async () => {
    let beyandDf = 0;
    let stpayDf = 0;
    let stpayDf1 = 0;
    await server
      .getDelivery()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          beyandDf = Number(payload[0].beyandDf);
          stpayDf = Number(payload[0].stpayDf);
          stpayDf1 = Number(payload[0].stpayDf1);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
    const booksPrice = Number(oneBookQty) * Number(oneBookPrice);
    if (Number(booksPrice) < stpayDf) {
      setShippingPrice(beyandDf);
      setTotalPrice(booksPrice + beyandDf);
      setSalesPrice(booksPrice);
      setPaymentAmount(booksPrice + beyandDf);
    } else {
      setShippingPrice(stpayDf1);
      setTotalPrice(booksPrice + stpayDf1);
      setSalesPrice(booksPrice);
      setPaymentAmount(booksPrice + beyandDf);
    }
  };

  // 주소(우편번호) 검색 API 호출
  const searchPostcode = async () => {
    if (addrKeyword.length > 0) {
      await server
        .getPostcode(currentPage, 100, addrKeyword)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setAddressItem(payload.items);
            setCurrentPage(payload.currentPage);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // 주소 테이블 생성
  function createAddressList() {
    return (
      <div className="table">
        <ul className="row title">
          <li>우편번호</li>
          <li>주소</li>
        </ul>
        {AddressRow}
      </div>
    );
  }

  // 주소값 불러오기
  const AddressRow = addressItem?.map((item: any) => (
    <ul
      className="row"
      key={Math.random()}
      onClick={() => {
        if (post === undefined || post === '') {
          setPost(item.zipNo);
        }
        setReceiverPost(item.zipNo);
        setReceiverAddr(item.jibunAddr);
        setSearchVisable(false);
      }}
    >
      <li>{item.zipNo}</li>
      <li>
        <div>지번 : {item.jibunAddr}</div>
        <div>도로명 : {item.roadAddrPart1}</div>
      </li>
    </ul>
  ));

  // 입금예정일 날짜 함수 (yeyak)
  const generateYearOption = () => {
    const arr: any[] = [];
    const start = 2022;
    const end = new Date().getFullYear();
    for (let i = end; i >= start; i--) {
      arr.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
    }
    return arr;
  };
  const generateMonthOption = () => {
    const arr: any[] = [];
    for (let i = 1; i <= 12; i++) {
      arr.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
    }
    return arr;
  };
  const generateDateOption = () => {
    const arr: any[] = [];
    for (let i = 1; i <= 31; i++) {
      arr.push(
        <option value={i} key={i}>
          {i}
        </option>
      );
    }
    return arr;
  };

  // 주문하기 버튼 클릭 시 (Validation)
  const onClickOrder = () => {
    if (purchaserName.length <= 0) {
      dispatch(toast.error({ message: '구매자명을 확인해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (purchaserName.length > 14) {
      dispatch(
        toast.error({
          message: '구매자명이 입력 최대치를 초과하였습니다. (14자 이내)',
          title: '필수 입력 최대치 초과',
        })
      );
      return;
    }
    if (receiverName.length <= 0) {
      dispatch(
        toast.error({ message: '받으시는 분을 입력해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (receiverName.length > 14) {
      dispatch(
        toast.error({
          message: '받으시는 분 입력 최대치를 초과하였습니다. (14자 이내)',
          title: '필수 입력 항목 최대치 초과',
        })
      );
      return;
    }
    if (purchaserEmail.length <= 0 || receiverEmail.length <= 0) {
      dispatch(toast.error({ message: '이메일을 확인해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (purchaserEmail.length > 40 || receiverEmail.length > 40) {
      dispatch(
        toast.error({
          message: '이메일이 입력 최대치를 초과하였습니다. (40자 이내) 확인해주세요.',
          title: '필수 입력 항목 최대치 초과',
        })
      );
      return;
    }
    if (!phoneRule.test(param[0].purchaserPhone)) {
      dispatch(
        toast.error({
          message: '구매하시는 분의 휴대폰 번호를 확인해주세요.',
          title: '필수 입력 항목 누락',
        })
      );
      return;
    }
    if (!phoneRule.test(param[0].receiverPhone)) {
      dispatch(
        toast.error({
          message: '받으시는 분의 휴대폰 번호를 확인해주세요.',
          title: '필수 입력 항목 누락',
        })
      );
      return;
    }
    if (addr.length <= 0) {
      dispatch(
        toast.error({ message: '보내시는 분의 주소를 확인해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (addr.length > 90) {
      dispatch(
        toast.error({
          message: '보내시는 분의 주소 입력 최대치를 초과하였습니다. (90자 이내)',
          title: '필수 입력 항목 최대치 초과',
        })
      );
      return;
    }
    if (receiverAddr.length <= 0) {
      dispatch(
        toast.error({ message: '받으시는 분의 주소를 확인해주세요.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (receiverAddr.length > 90) {
      dispatch(
        toast.error({
          message: '받으시는 분의 주소 입력 최대치를 초과하였습니다. (90자 이내)',
          title: '필수 입력 항목 최대치 초과',
        })
      );
      return;
    }
    if (payer.length <= 0) {
      dispatch(toast.error({ message: '입금자명을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (payer.length > 20) {
      dispatch(
        toast.error({
          message: '입금자명 입력 최대치를 초과하였습니다. (20자 이내)',
          title: '필수 입력 항목 최대치 초과',
        })
      );
      return;
    }
    if (internetExplorer) {
      dispatch(
        toast.error({
          message:
            '"Internet Explorer"는 주문 진행이 불가합니다. Edge, Chrome, Whale, Safari 등 타 브라우저를 이용해 주시기 바랍니다.',
          title: '브라우저 지원 중단',
        })
      );
      return;
    }
    PostOrder();
  };

  // 주문하기 API 호출
  const PostOrder = async () => {
    await server
      .postOrders(param)
      .then((payload) => {
        if (payload.code === 501) {
          dispatch(
            toast.error({ message: '주문이 정상적으로 접수되지 않아 잠시 뒤에 시도해 주세요.' })
          );
        } else if (window.localStorage.getItem('token') === null) {
          dispatch(
            toast.info({
              title: '비회원 주문 완료',
              message: '비회원 주문내역는 유선전화(02-701-7421~2)를 통해 확인하실 수 있습니다.',
            })
          );
          props.history.push('/');
        } else {
          dispatch(toast.info({ message: '주문이 완료되었습니다.' }));
          props.history.push('/');
        }
      })
      .catch((error) => {
        dispatch(
          toast.error({ message: '주문이 정상적으로 접수되지 않아 잠시 뒤에 시도해 주세요.' })
        );
        console.log(error);
      });
  };

  // order 리턴값
  return (
    <>
      <main className="sub order wrapper">
        <div className="content">
          <div className="breadscrumb">
            <>Home</>
            {' > '}
            <>주문하기</>
          </div>
          <div className="title">
            <h2>주문하기</h2>
            <p>주문하신 분의 정보와 배송받으실 곳의 정보를 입력해주시기 바랍니다.</p>
            <br />
            <span>
              ※ &quot;<b style={{ color: '#EB5353' }}>Internet Explorer</b>&quot;는 현재
              <b style={{ color: '#EB5353' }}> 브라우저 지원 중단</b>으로 주문이 누락 될 수
              있습니다. <br />
              Edge, Chrome, Whale, Safari 등 타 브라우저를 이용해 주시기 바랍니다.
            </span>
          </div>
          <div className="flex-container">
            <div className="order-information">
              <section className="list">{createCartList()}</section>
              <section>
                <h3>주문하신 분 정보확인</h3>
                <ul className="inputs">
                  <li>
                    <span className="required">구매자명</span>
                    <input
                      type="text"
                      maxLength={14}
                      value={purchaserName}
                      onChange={(event) => {
                        setPurchaserName(event.target.value);
                      }}
                    />
                  </li>
                  <li>
                    <span className="required">이메일</span>
                    <input
                      type="email"
                      maxLength={40}
                      value={purchaserEmail}
                      onChange={(event) => {
                        setPurchaserEmail(event.target.value);
                      }}
                    />
                  </li>
                  <li className="phone">
                    <span>전화번호</span>
                    <div>
                      <input
                        type="number"
                        value={purTel1}
                        onChange={(event) => {
                          setPurTel1(event.target.value);
                        }}
                      />
                      <span>-</span>
                      <input
                        type="number"
                        value={purTel2}
                        onChange={(event) => {
                          setPurTel2(event.target.value);
                        }}
                      />
                      <span>-</span>
                      <input
                        type="number"
                        value={purTel3}
                        onChange={(event) => {
                          setPurTel3(event.target.value);
                        }}
                      />
                    </div>
                  </li>
                  <li className="phone">
                    <span className="required">휴대폰</span>
                    <div>
                      <input
                        type="number"
                        value={purPhone1}
                        onChange={(event) => {
                          setPurPhone1(event.target.value);
                        }}
                      />
                      <span>-</span>
                      <input
                        type="number"
                        value={purPhone2}
                        onChange={(event) => {
                          setPurPhone2(event.target.value);
                        }}
                      />
                      <span>-</span>
                      <input
                        type="number"
                        value={purPhone3}
                        onChange={(event) => {
                          setPurPhone3(event.target.value);
                        }}
                      />
                    </div>
                  </li>
                  <li>
                    <span className="required">주소</span>
                    <input
                      type="text"
                      maxLength={90}
                      value={purchaserAddr}
                      onChange={(event) => {
                        setPurchaserAddr(event.target.value);
                        setAddr(event.target.value);
                      }}
                    />
                  </li>
                </ul>
              </section>
              <section>
                <h3>받으시는 분 정보확인</h3>
                <div className="checkbox">
                  <input
                    id="ch"
                    type="checkbox"
                    defaultChecked={isSameBuyerInfo}
                    onChange={() => {
                      onCheckReceiverInfo(!isSameBuyerInfo);
                    }}
                  />
                  <label htmlFor="ch">구매자 정보와 일치하면 체크하세요.</label>
                </div>
                <ul className="inputs">
                  <li>
                    <span className="required">받으시는 분</span>
                    <input
                      type="text"
                      maxLength={14}
                      value={receiverName}
                      onChange={(event) => {
                        setReceiverName(event.target.value);
                      }}
                    />
                  </li>
                  <li>
                    <span className="required">이메일</span>
                    <input
                      type="email"
                      maxLength={40}
                      value={receiverEmail}
                      onChange={(event) => {
                        setReceiverEmail(event.target.value);
                      }}
                    />
                  </li>
                  <li className="phone">
                    <span>전화번호</span>
                    <div>
                      <input
                        type="number"
                        value={reTel1}
                        onChange={(event) => {
                          setReTel1(event.target.value);
                        }}
                      />
                      <span>-</span>
                      <input
                        type="number"
                        value={reTel2}
                        onChange={(event) => {
                          setReTel2(event.target.value);
                        }}
                      />
                      <span>-</span>
                      <input
                        type="number"
                        value={reTel3}
                        onChange={(event) => {
                          setReTel3(event.target.value);
                        }}
                      />
                    </div>
                  </li>
                  <li className="phone">
                    <span className="required">휴대폰</span>
                    <div>
                      <input
                        type="number"
                        value={rePhone1}
                        onChange={(event) => {
                          setRePhone1(event.target.value);
                        }}
                      />
                      <span>-</span>
                      <input
                        type="number"
                        value={rePhone2}
                        onChange={(event) => {
                          setRePhone2(event.target.value);
                        }}
                      />
                      <span>-</span>
                      <input
                        type="number"
                        value={rePhone3}
                        onChange={(event) => {
                          setRePhone3(event.target.value);
                        }}
                      />
                    </div>
                  </li>
                  <li className="address">
                    <span className="required">주소</span>
                    <input
                      type="text"
                      maxLength={90}
                      placeholder="클릭 시 주소 검색 가능"
                      value={receiverAddr}
                      onChange={(event) => {
                        setReceiverAddr(event.target.value);
                      }}
                      onFocus={() => {
                        setSearchVisable(true);
                      }}
                    />
                  </li>
                  <li className="address">
                    <span>상세주소</span>
                    <input
                      type="text"
                      maxLength={90}
                      defaultValue={receiverDetailAddr}
                      onChange={(event) => {
                        setReceiverDetailAddr(event.target.value);
                      }}
                    />
                  </li>
                  <li>
                    <span>요청사항</span>
                    <input
                      type="text"
                      value={etc}
                      maxLength={90}
                      onChange={(event) => {
                        setEtc(event.target.value);
                      }}
                    />
                  </li>
                </ul>
              </section>
            </div>
            <div className="order-container">
              <h3>전체상품: {Number(oneBookQty)}개</h3>
              <ul className="total">
                <li>
                  <span>주문금액</span>
                  <span className="price">
                    {(Number(oneBookQty) * Number(oneBookPrice)).toLocaleString()}
                  </span>
                </li>
                <li>
                  <span>배송비</span>
                  <span className="price">+ {Number(shippingPrice).toLocaleString()}</span>
                </li>
                <li>
                  <span>결제예정금액</span>
                  <span className="price">{Number(totalPrice).toLocaleString()}</span>
                </li>
              </ul>
              <ul className="bank">
                <li>
                  <span className="required">결제방법</span>
                  <input id="a" type="radio" defaultChecked />
                  <label htmlFor="a">{paymentOption}</label>
                </li>
                <li>
                  <span>입금예정일</span>
                  <div>
                    <div className="selectbox">
                      <select
                        name=""
                        id=""
                        onChange={(event) => {
                          setYearOption(event.target.value);
                        }}
                        defaultValue={yearOption}
                      >
                        {generateYearOption()}
                      </select>
                    </div>
                    <div className="selectbox">
                      <select
                        name=""
                        id=""
                        onChange={(event) => {
                          setMonthOption(event.target.value);
                        }}
                        defaultValue={monthOption}
                      >
                        {generateMonthOption()}
                      </select>
                    </div>
                    <div className="selectbox">
                      <select
                        name=""
                        id=""
                        onChange={(event) => {
                          setDateOption(event?.target.value);
                        }}
                        defaultValue={dateOption}
                      >
                        {generateDateOption()}
                      </select>
                    </div>
                  </div>
                </li>
                <li>
                  <span>입금자명</span>
                  <input
                    type="text"
                    onChange={(event) => {
                      setPayer(event.target.value);
                    }}
                  />
                </li>
                <li>
                  <strong>
                    계좌번호: {bank} ({bankhost})
                  </strong>
                </li>
              </ul>
              <div className="buttons">
                <button type="button" className="btn-main" onClick={onClickOrder}>
                  주문완료
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <div className={`modal modal-address ${searchVisable ? 'active' : ''}`}>
        <header>
          <div className="title">
            <h3>주소 찾기</h3>
            <svg
              className="close"
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 18 18"
              onClick={() => {
                setSearchVisable(false);
              }}
            >
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
            </svg>
          </div>
          <section>
            <p>검색어(도로명,건물명,지번)를 입력해주세요(지번+도로명 통합 검색)</p>
          </section>
          <section className="search">
            <input
              type="text"
              defaultValue={addrKeyword}
              onChange={(event) => {
                setAddrKeyword(event.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  searchPostcode();
                }
              }}
              placeholder='예) "서소문로 26" 또는 "중림동 157-2'
            />
            <button
              type="button"
              onClick={() => {
                searchPostcode();
              }}
            >
              검색
            </button>
          </section>
        </header>
        <div className="modal-content">
          <div className="address-results">
            <div className="content">{createAddressList()}</div>
          </div>
        </div>
      </div>
      <div className={`overlay ${searchVisable ? 'active' : ''}`} />
    </>
  );
}
